import script from "./SecondTawafPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondTawafPage.vue?vue&type=script&setup=true&lang=js"

import "./SecondTawafPage.vue?vue&type=style&index=0&id=fc5272a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc5272a6"]])

export default __exports__